import { render } from "./EmailVerification.vue?vue&type=template&id=1dbb968c&ts=true"
import script from "./EmailVerification.vue?vue&type=script&lang=ts"
export * from "./EmailVerification.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__